import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-upcoming-tab',
  templateUrl: './salvage-upcoming-tab.component.html',
})
export class SalvageUpcomingTabComponent {
  @Input() context!: SalvageTabContext;
}
